import { render, staticRenderFns } from "./tyxy.vue?vue&type=template&id=f311a70a&scoped=true&"
import script from "./tyxy.vue?vue&type=script&lang=js&"
export * from "./tyxy.vue?vue&type=script&lang=js&"
import style0 from "./tyxy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./tyxy.vue?vue&type=style&index=1&id=f311a70a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f311a70a",
  null
  
)

export default component.exports